import { Injectable, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

// eslint-disable-next-line @typescript-eslint/naming-convention
declare let Cookiebot: any;

@Injectable({
    providedIn: 'root',
})
export class SeoService {
    fbHasBeenInjected = false;
    siteControlHasBeenInjected = false;

    constructor(@Inject(DOCUMENT) private doc: Document) {
        if (!Cookiebot || !Cookiebot.hasResponse) {
            window.addEventListener(
                'CookiebotOnAccept',
                (e) => {
                    if (Cookiebot.consent.marketing && Cookiebot.consent.statistics) {
                        this.injectFacebookPixel();
                    }
                },
                false
            );

            return;
        }

        if (Cookiebot.consent.marketing && Cookiebot.consent.statistics) {
            this.injectFacebookPixel();
        }
    }

    setCanonicalLink() {
        let link: HTMLLinkElement = this.doc.querySelector('link[rel="canonical"]');

        if (!link) {
            link = this.doc.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.doc.head.appendChild(link);
        }

        // strip url parameters
        const url = this.doc.URL.split('?')[0];
        link.setAttribute('href', url);
    }

    injectFacebookPixel() {
        if (this.fbHasBeenInjected) {
            return;
        }

        this.fbHasBeenInjected = true;

        const facebookPixelScript = `
            !(function(f, b, e, v, n, t, s) {
                if (f.fbq) return;
                n = f.fbq = function() {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = !0;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

            fbq('init', '156997254649972');
            fbq('track', 'PageView');`;

        this.injectScript(facebookPixelScript);
    }

    private injectScript(script: string) {
        const scriptNode = document.createElement('script');
        scriptNode.type = 'text/javascript';
        scriptNode.innerHTML = script;
        scriptNode.async = true;

        document.getElementsByTagName('head')[0].appendChild(scriptNode);
    }
}
